<div class="home-stage">
  <div class="home-stage__wrapper">
    <!-- Teaser 1 -->
    <div class="home-stage__loader-lg">
      <div class="home-stage__loader-lg__image">
        <ngx-skeleton-loader
          count="1"
          appearance="circle"
          [theme]="{
            width: '100%',
            height: '100%',
            margin: '0',
            'border-radius': '0',
          }"
        >
        </ngx-skeleton-loader>
      </div>
      <div class="home-stage__loader-lg__headline">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '10px',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="home-stage__loader-lg__link">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <!-- End Teaser 1 -->
  </div>
  <div class="home-stage__wrapper">
    <!-- Teaser 2 -->
    <div class="home-stage__loader-sm">
      <ngx-skeleton-loader
        count="1"
        appearance="circle"
        animation="false"
        [theme]="{
          width: '100%',
          height: '100%',
          margin: '0',
          'border-radius': '0',
        }"
      >
      </ngx-skeleton-loader>
      <div class="home-stage__loader-sm__wrapper">
        <div class="home-stage__loader-sm__content">
          <div class="home-stage__loader-sm__content__headline">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'background-color': '#f9f9fa',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="home-stage__loader-sm__content__button">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'background-color': '#f9f9fa',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div class="home-stage__loader-sm__icon">
          <ngx-skeleton-loader
            [theme]="{
              appearance: 'circle',
              width: '100%',
              'border-radius': '0',
              height: '100%',
              'background-color': '#f9f9fa',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <!-- End Teaser 2 -->
    <!-- Teaser 3 -->
    <div class="home-stage__loader-md">
      <div class="home-stage__loader-md__image">
        <ngx-skeleton-loader
          count="1"
          appearance="circle"
          [theme]="{
            width: '100%',
            height: '100%',
            margin: '0',
            'border-radius': '0',
          }"
        >
        </ngx-skeleton-loader>
      </div>
      <div class="home-stage__loader-md__headline">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '10px',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="home-stage__loader-md__link">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <!-- End Teaser 3 -->
  </div>
</div>
